define('model/MenuModel',['require','backbone','Config'],function (require) {

	var Backbone = require('backbone');
    var Config = require('Config');
	
	/**
	 * Menu model. Stores active menu item
	 *
	 * @class MenuModel
	 */
	return Backbone.Model.extend({
		
		defaults: {
			active_menu_item: '',
			plugins: {}
		},
		
		initialize: function () {
            var plugins = {};
            _.each(Config.getInstance().getOption('plugins'), function (plugin, pluginName) {
                plugins[pluginName] = parseInt(plugin.is_active);
            });

            this.set('plugins', plugins);

          //  this.initStaticPages();
		},

/*		initStaticPages : function () {
            if (Config.getInstance().getPluginStatus('static_page')) {
                this.set('static_pages', Config.getInstance().getOption('static_pages'));
            }
        }*/

	
	});

});
